import React, { useEffect, useState } from "react";
import {
  Box, Card, Grid, Typography,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import DescriptionIcon from "@mui/icons-material/Description";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CategoryIcon from "@mui/icons-material/Category";
import axios from "axios";
import api , { API_BASE_URL } from "../../../../utils/api";
import RequestFilesViewer from "./RequestFilesViewer";

const RequestDetailsPanel = ({ requestDetails }) => {
  const [types, setTypes] = useState([]);
  const [subtypes, setSubtypes] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [users, setUsers] = useState([]);

  // Fetch data needed for labels
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [typeRes, subtypeRes, priorityRes, userRes] = await Promise.all([
          api.get(`/architectural-request-types`),
          api.get(`/architectural-request-subtypes?typeId=${requestDetails?.request_type?.[0] || ""}`),
          api.get(`/priority-levels`),
          api.get(`/users-by-role`),
        ]);

        setTypes(typeRes.data);
        setSubtypes(subtypeRes.data);
        setPriorities(priorityRes.data);
        setUsers(userRes.data);
      } catch (err) {
        console.error("Failed to load reference data", err);
      }
    };

    fetchData();
  }, [requestDetails]);

  const requestTypeName = requestDetails?.request_type?.[1] || "N/A";
  const subtypeName = subtypes.find(s => s.subtype_id === Number(requestDetails?.subtype_id))?.subtype_name || "N/A";
  const priorityName = priorities.find(p => p.priority_value === requestDetails?.priority)?.display_name || "N/A";
  const assignedTo = users.find(u => u.UserID === requestDetails?.assigned_to);
  const assignedToName = assignedTo ? `${assignedTo.Name} ${assignedTo.Lastname} (${assignedTo.RoleName})` : "N/A";

  return (
    <Box>
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 500, color: "#666" }}>
          Request ID: <strong>REQ-{requestDetails?.id}</strong>
        </Typography>
      </Box>

      <Grid container spacing={2}>
        {/* Request Type */}
        <Grid item xs={12}>
          <Card sx={{ p: 2 }}>
            <Box display="flex" alignItems="center" gap={2}>
              <InfoIcon color="primary" />
              <Typography variant="body2">
                <strong>Request Type:</strong> {requestTypeName}
              </Typography>
            </Box>
          </Card>
        </Grid>

        {/* Subtype */}
        <Grid item xs={12}>
          <Card sx={{ p: 2 }}>
            <Box display="flex" alignItems="center" gap={2}>
              <CategoryIcon color="info" />
              <Typography variant="body2">
                <strong>Subtype:</strong> {subtypeName}
              </Typography>
            </Box>
          </Card>
        </Grid>

     
        {/* Description */}
        <Grid item xs={12}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <DescriptionIcon color="secondary" />
            <Typography variant="body2">
              <strong>Description:</strong> {requestDetails?.description || "No Description Available"}
            </Typography>
          </Card>
        </Grid>

       
        

        {/* Status */}
        <Grid item xs={12}>
          <Card sx={{ p: 2, display: "flex", alignItems: "center", gap: 2 }}>
            <CheckCircleIcon color={requestDetails?.status === "Approved" ? "success" : "error"} />
            <Typography variant="body2">
              <strong>Status:</strong> {requestDetails?.status || "N/A"}
            </Typography>
          </Card>
        </Grid>

        {/* Files Viewer */}
        <Grid item xs={12}>
          <RequestFilesViewer requestId={requestDetails?.id} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RequestDetailsPanel;
